const state = {
  'dark-theme': {
    '--main-color':  '#002A53',
    '--summary-panel-border-color': 'var(--main-color)',
    '--panel-bar-bg-color': 'var(--main-color)',
    '--white-color': '#FFFFFF',
    '--black-color': '#000000',
    '--main-title-color': 'var(--white-color)',
    '--header-right-label-color': 'var(--white-color)',
    '--dashboard-bg-color': '#001121',
    '--dashboard-color': 'var(--black-color)',
    '--panel-body-bg-color': '#0B0F28',
    '--summary-panel-bg-color' :'linear-gradient(to bottom, #002A53, #001D3A)',
    '--summary-panel-bg-title-color': 'var(--white-color)',
    '--v-icon-color': 'var(--white-color)',
    '--tr-even-gradient-color-1': '#001D3A',
    '--tr-even-gradient-color-2': '#001121',
    '--tr-odd-gradient-color': '#001121',
    '--period-box-bg-color': '#001121',
    '--period-box-menu-bg-color': '#001121',
    '--bar-chart-gradient': '#EEEE07',
    '--instagram-bg-color': 'var(--black-color)',
    '--instagram-title-color': 'var(--white-color)',
    '--chart-area-bg-color': 'var(--main-color)',
    '--chart-area-border-color': 'var(--main-color)',
    '--instagram-tr-even-gradient-color-1': 'var(--black-color)',
    '--line-chart-tooltip-border-color': '001121',
    '--line-chart-tooltip-bg-color': '#001121',
    '--line-chart-tooltip-title-color': 'var(--white-color)',
    '--line-chart-y-color': 'rgba(141,140,142,0.2)',
    '--line-chart-y-curve-color': '#5AC3EF',
    '--left-area-item-odd-gradient-1': '#002A53',
    '--left-area-item-odd-gradient-2': '#001D3A',
    '--symbol-details-button-bg-color': '#237BCB',
    '--symbol-details-button-text-color': 'var(--white-color)',
    '--symbol-details-button-hover-color': '#9A9D9E',
    '--right-info-color': 'var(--main-color)',
    '--multiple-selection-item-color': 'var(--white-color)'
  },
  'light-theme': {
    '--main-color':  '#237BCB',
    '--summary-panel-border-color': 'var(--main-color)',
    '--summary-panel-dark-color': 'var(--main-color)',
    '--panel-bar-bg-color': 'var(--main-color)',
    '--white-color': '#FFFFFF',
    '--black-color': '#000000',
    '--main-title-color': 'var(--black-color',
    '--header-right-label-color': 'var(--main-color)',
    '--dashboard-bg-color': 'var(--white-color)',
    '--dashboard-color': '',
    '--panel-body-bg-color': '#F0F0F0',
    '--summary-panel-bg-color': 'linear-gradient(to bottom, #E4F5FF, var(--white-color))',
    '--summary-panel-bg-title-color': '#002A53',
    '--v-icon-color': '',
    '--tr-even-gradient-color-1': '#E4F5FF',
    '--tr-even-gradient-color-2': 'var(--white-color)',
    '--tr-odd-gradient-color': 'var(--white-color)',
    '--period-box-bg-color': 'var(--main-color)',
    '--period-box-menu-bg-color': 'var(--main-color)',
    '--bar-chart-gradient': '#EEEE07',
    '--instagram-bg-color': '#F0F0F0',
    '--instagram-title-color': 'var(--black-color)',
    '--chart-area-bg-color': 'var(--white-color)',
    '--chart-area-border-color': 'var(--main-color)',
    '--instagram-tr-even-gradient-color-1': '#F0F0F0',
    '--line-chart-tooltip-border-color': 'var(--main-color)',
    '--line-chart-tooltip-bg-color': 'var(--main-color)',
    '--line-chart-tooltip-title-color': 'var(--white-color)',
    '--line-chart-y-color': '#D4D2D6',
    '--line-chart-y-curve-color': '#002A53',
    '--left-area-item-odd-gradient-1': '#237BCB',
    '--left-area-item-odd-gradient-2': '#145895',
    '--symbol-details-button-bg-color': '#E4F5FF',
    '--symbol-details-button-text-color': '#002A53',
    '--symbol-details-button-hover-color': '#9A9D9E',
    '--right-info-color': 'var(--main-color)',
    '--multiple-selection-item-color': 'var(--black-color)'
  }
};

export default {
  namespaced: true,
  state
};
